// 字典（hok-delivery）
import request from '@/utils/request6'

// 年级+教材版本树形字典（年级为父节点，教材版本为子节点，返回 desc 和 val）
export function getGradeVersionTree() {
  return request({
    url: '/cloud/delivery/dict/grade-version-tree',
    method: 'get'
  })
}
